<template>
  <div ref="window" class="smoothwindow">
    <div class="smoothwindow__slider" ref="slider" :style="{ 'transform': `translateX(${-200 * (slide - 1)}%)` }">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    slide: 1,
    timer: undefined
  }),
  props: {
    slidecount: { type: Number, default: 1 },
    special: { type: Boolean, default: false }
  },
  methods: {
    async toSlide(next) {
      if (next === undefined)
        next = this.slide + 1
      if ((next > this.slidecount) || (next < 1)) {
        if (next == this.slidecount + 1) {
          this.$refs.window.querySelector('.smoothwindow__slider>.active').classList.remove('active')
          return this.$emit('finished')
        }
        else
          return console.error('Неверный шаг: ' + next)
      }

      if (this.special && (next == 3) && (this.slide == 2)) {
        let ok = await this.$store.dispatch('sendForm')
        if (!ok)
          return
      }

      clearTimeout(this.timer)
      this.$refs.window.classList.add('restricted')
      this.$refs.slider.style.setProperty('height', this.$refs.slider.offsetHeight + 'px')
      this.slide = next
      this.$refs.window.querySelector('.smoothwindow__slider>.active').classList.remove('active')
      this.$refs.slider.children[next - 1].classList.add('active')
      try {
        window.scroll({ top: this.$refs.window.querySelector('.smoothwindow__slider>.active').getBoundingClientRect().top + document.documentElement.scrollTop - 200, behavior: 'smooth' });
        //eslint-disable-next-line
      } catch (err) { }

      this.$nextTick(() => {
        let active = this.$refs.window.querySelector('.smoothwindow__slider>.active'), nextHeight
        if (active)
          nextHeight = active.scrollHeight + 'px'
        else
          nextHeight = 'auto'
        this.$nextTick(() => {
          this.$refs.slider.style.setProperty('transition', 'transform .5s ease-out, height .5s ease-out')
          window.requestAnimationFrame(() => {
            this.$refs.slider.style.setProperty('height', nextHeight)
          })
        })
        this.timer = setTimeout(() => {
          this.$refs.slider.style.removeProperty('height')
          this.$refs.slider.style.removeProperty('transition')
          this.$refs.window.classList.remove('restricted')
        }, 500)
      })
    }
  },
  watch: {
    slide: {
      handler(v) {
        this.$emit('slideChanged', v)
      },
      immediate: true
    }
  }
}
</script>

<style lang="sass">
.smoothwindow
  overflow: hidden
  padding: 500px 50%
  width: 200%
  margin: -500px -50%
  &.restricted
    width: 100%
    padding: 0px 0
    margin: 0
  &__slider
    display: flex
    align-items: flex-start
    width: 100%
    transition: transform .5s ease-out
    >*
      width: 100%
      flex-shrink: 0
      margin-right: 100%
  
</style>